import { useEffect, useRef } from "react";
import DefaultButton from "./DefaultButton";

export default function TextVideo({ title, description, videoSrc, handleClick }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        video.muted = true;
        video.play().catch(() => {});
    }, []);

    return (
        <section className="flex flex-col md:flex-row min-h-screen md:h-screen">
           <div className="flex flex-col justify-center px-6 py-5 md:px-14 gap-10 md:w-1/2 text-center md:text-left">
                <h2 className="lg:text-5xl text-4xl text-mcare-green font-semibold md:drop-shadow-lg text-balance panoragraf-light" data-aos="fade-up" data-aos-duration="1000">
                    {title}
                </h2>

                {description}
                {/* <DefaultButton text="Prenota una visita" link="#formContatti" buttonClass="lg:w-full xl:w-1/2" /> */}
                <button
                    onClick={handleClick}
                    id="heroSection"
                    className="progress-button-mcare px-8 py-2 uppercase font-semibold tracking-wider text-center transition duration-300 ease-in-out w-full lg:w-fit"
                  >
                    Prenota una visita
                  </button>
            </div>
            <div className="w-full md:w-1/2 h-full relative">
                <div className="bg-black/50 absolute inset-0"/>
                <video
                    ref={videoRef}
                    src={videoSrc}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    className="w-full h-full object-cover shadow-lg"
                />
            </div>
        </section>
    );
}